import useAxiosInterceptor from 'src/services/interceptor';
import { patientApiPaths } from '../constants';

class MonthEndAlertsService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getMonthEndAlertCount = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.getMonthEndAlertCount}${
        payload?.source !== 'DASHBOARD' ? '/closeout' : ''
      }/alert-count`,
      {
        params: payload?.param,
      }
    );
  };
  getMonthEndAlertThemeCount = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.getMonthEndAlertCount}/theme?timePeriod=${payload.timePeriod}`
    );
  };
  getOwnerAlertCount = (payload: any) => {
    return this.axiosInstance.get(`${patientApiPaths.getMonthEndAlertCount}/closeout/owner`, {
      params: payload?.param,
    });
  };

  getListOfMonthEndAlerts = (payload: any) => {
    const path = payload?.source === 'CLOSEOUT' ? 'closeout/range' : 'all';
    return this.axiosInstance.get(`${patientApiPaths.getMonthEndAlertCount}/${path.trim()}`, {
      params: { ...payload?.param },
    });
  };

  certifyMonthEndAlertCycle = (payload: object) => {
    return this.axiosInstance.post(patientApiPaths.certifyMonthEnd, payload);
  };

  getCertificationStatus = (payload: object) => {
    return this.axiosInstance.get(patientApiPaths.getCertificationStatus, {
      params: { ...payload },
    });
  };

  getMonthEndAlertsPdfUrl = (startDate: string, endDate: string) => {
    return this.axiosInstance.get(
      `${patientApiPaths.getMonthEndAlertCount}/print?startDate=${startDate}&endDate=${endDate}`
    );
  };

  // BOPS-126: per-row "Refresh" for a Treatment-but-No-Labor error. The row only has the alert
  // UUID; the backend resolves the (facility, therapist, day) and re-checks it (clears if labor was
  // logged that day, otherwise rebuilds). Facility_id / auth headers are added by the interceptor.
  refreshTreatmentButNoLaborByAlert = (alertUuid: string) => {
    return this.axiosInstance.post(
      `${patientApiPaths.getMonthEndAlertCount}/treatment-but-no-labor/refresh/by-alert/${alertUuid}`
    );
  };
}

const monthEndAlertsService = new MonthEndAlertsService();

Object.freeze(monthEndAlertsService);

export default monthEndAlertsService;
